import { render, staticRenderFns } from "./NameAndDecriptionStep.vue?vue&type=template&id=213ca44c&scoped=true"
import script from "./NameAndDecriptionStep.vue?vue&type=script&lang=ts"
export * from "./NameAndDecriptionStep.vue?vue&type=script&lang=ts"
import style0 from "./NameAndDecriptionStep.vue?vue&type=style&index=0&id=213ca44c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213ca44c",
  null
  
)

export default component.exports